// One portal per supported profile type. `path` is the URL segment used by both the admin pages
// (Community Hub › Portals › /portals/{path}) and the participant page (/{profile}/portals/{path}).
// `tabs` are the participant tabs beyond the shared Announcements / Discussions / Settings.
export const PORTAL_TYPES = {
  AMBASSADOR: {
    type: "AMBASSADOR",
    path: "ambassador",
    label: "Ambassadors",
    portalLabel: "Ambassador Portal",
    noun: "ambassador",
    icon: "fa-people-group",
    tabs: []
  },
  BUSINESS: {
    type: "BUSINESS",
    path: "business",
    label: "Businesses",
    portalLabel: "Business Portal",
    noun: "business",
    icon: "fa-store",
    tabs: []
  },
  VENDOR: {
    type: "VENDOR",
    path: "vendor",
    label: "Vendors",
    portalLabel: "Vendor Portal",
    noun: "vendor",
    icon: "fa-truck",
    tabs: []
  },
  ORGANIZATION: {
    type: "ORGANIZATION",
    path: "organization",
    label: "Organizations",
    portalLabel: "Partner Portal",
    noun: "organization",
    icon: "fa-handshake",
    tabs: [
      { key: "events", label: "Events", icon: "fa-calendar" },
      { key: "funding", label: "Funding", icon: "fa-hand-holding-dollar" }
    ]
  }
};

export const PORTAL_TYPE_LIST = Object.values(PORTAL_TYPES);

export const portalTypeFromPath = path => PORTAL_TYPE_LIST.find(p => p.path === path?.toLowerCase()) ?? null;
